import { store } from 'shared/stores/core/decorators';
import { translateRegion } from './legacy-translations';

@store('REGION_TOOLBAR')
export class RegionToolbarStore {
    state = {
      isVisible: false,
      position: {
        clientX: 0,
        clientY: 0
      }
    };

    // Listen for uScope annotations events and update state accordingly
    AFTER_VIEWPORT_CREATED ({get, dispatch}, viewport) {
      // When someone clicks an annotation, make the region toolbar visible
      viewport.events.on('us:annotations:show-context-menu', ({event, region}) => {
        // First check to see if a right-click-sensitive operation is underway.
        // Ugh. I'm not really sure how to disentangle this ATM...
        const {uScope} = get('USCOPE');

        if (uScope.isRegionCopyActive()) {
          uScope.stopCopyMoveRegion();
          return;
        }

        dispatch('SHOW_REGION_TOOLBAR', {
          event,
          region: translateRegion(region)
        });
      });
    }

    SHOW_REGION_TOOLBAR ({dispatch}, {event, region}) {
      this.state.isVisible = true;
      this.state.position.clientX = event.clientX;
      this.state.position.clientY = event.clientY;

      // Only select the region if there's a region id (don't try to select the "hilight" region
      if (region.id) {
        dispatch('SELECT_REGION', {region, reposition: false});
      }
    }

    HIDE_REGION_TOOLBAR ({state}) {
      state('REGION_TOOLBAR').isVisible = false;
    }
}



// WEBPACK FOOTER //
// ./src/shared/stores/annotations/RegionToolbarStore.js